import { render } from "./setFileCheck.vue?vue&type=template&id=aaada564&scoped=true"
import script from "./setFileCheck.vue?vue&type=script&lang=js"
export * from "./setFileCheck.vue?vue&type=script&lang=js"

import "./setFileCheck.vue?vue&type=style&index=0&id=aaada564&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aaada564"]])

export default __exports__